import {FC} from 'react';
import {useTranslation} from 'react-i18next';

import InvestorAccountsList from '../investor-accounts-list';

type Props = {
  investorNo: string;
};

export const AccountStep: FC<Props> = ({investorNo}) => {
  const {t} = useTranslation('common', {keyPrefix: 'components.new-document-creation.dialog.content'});

  return (
    <>
      <h3 className="font-bold" data-testid="account-step-separator">
        {t('step-account.instructions')}
      </h3>

      <InvestorAccountsList investorNo={investorNo} />
    </>
  );
};
